/** Format a Date as YYYY-MM-DD (local). */
function formatIso(d: Date): string {
  return (
    d.getFullYear() +
    '-' +
    String(d.getMonth() + 1).padStart(2, '0') +
    '-' +
    String(d.getDate()).padStart(2, '0')
  );
}

/** Today's date as YYYY-MM-DD (local). */
export function todayIso(): string {
  return formatIso(new Date());
}

/** YYYY-MM-DD → DD/MM/YYYY (short FR). */
export function frDate(iso: string): string {
  if (!iso) return '';
  const [y, m, d] = iso.split('-');
  return `${d}/${m}/${y}`;
}

/** iso date shifted by `deltaDays` calendar days (noon anchor avoids DST edge cases). */
export function addDaysIso(iso: string, deltaDays: number): string {
  const d = new Date(iso + 'T12:00:00');
  d.setDate(d.getDate() + deltaDays);
  return formatIso(d);
}

/** iso date shifted by `deltaMonths` calendar months. */
export function addMonthsIso(iso: string, deltaMonths: number): string {
  const d = new Date(iso + 'T12:00:00');
  d.setMonth(d.getMonth() + deltaMonths);
  return formatIso(d);
}
